import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-dark-surface border-t border-dark-border mt-20">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <img
                src="/images/logo.webp"
                alt="BetSprinto"
                className="h-8 w-auto"
                loading="lazy"
                width="32"
                height="32"
              />
              <span className="text-xl font-bold text-gradient">BetSprinto</span>
            </div>
            <p className="text-gray-400 text-sm">
              Votre guide expert pour les meilleures offres de paris sportifs en France.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Liens rapides</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-accent-primary transition-colors text-sm">
                  Accueil
                </Link>
              </li>
              <li>
                <Link
                  to="/comparaison"
                  className="text-gray-400 hover:text-accent-primary transition-colors text-sm"
                >
                  Comparaison
                </Link>
              </li>
              <li>
                <Link
                  to="/a-propos"
                  className="text-gray-400 hover:text-accent-primary transition-colors text-sm"
                >
                  À propos
                </Link>
              </li>
              <li>
                <Link
                  to="/faq"
                  className="text-gray-400 hover:text-accent-primary transition-colors text-sm"
                >
                  FAQ
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-white font-semibold mb-4">Légal</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/politique-confidentialite"
                  className="text-gray-400 hover:text-accent-primary transition-colors text-sm"
                >
                  Politique de confidentialité
                </Link>
              </li>
              <li>
                <Link
                  to="/cookies"
                  className="text-gray-400 hover:text-accent-primary transition-colors text-sm"
                >
                  Politique des cookies
                </Link>
              </li>
              <li>
                <Link
                  to="/conditions"
                  className="text-gray-400 hover:text-accent-primary transition-colors text-sm"
                >
                  Conditions d'utilisation
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-semibold mb-4">Contact</h3>
            <p className="text-gray-400 text-sm mb-2">Email: contact@betsprinto.com</p>
            <p className="text-gray-400 text-sm">
              <strong className="text-yellow-500">⚠️ Jeu responsable</strong>
              <br />
              18+ • Jeu excessif = danger
            </p>
          </div>
        </div>

        {/* Regulatory Organizations */}
        <div className="border-t border-dark-border mt-8 pt-8">
          <h3 className="text-white font-semibold mb-4 text-center">Organisations de régulation et d'aide</h3>
          <div className="flex flex-wrap justify-center items-center gap-6 mb-8">
            <a
              href="https://anj.fr/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:opacity-80 transition-opacity"
              aria-label="ANJ - Autorité Nationale des Jeux"
            >
              <img
                src="/images/footer/anj.webp"
                alt="ANJ"
                className="h-10 w-auto"
                loading="lazy"
              />
            </a>
            <a
              href="https://www.hippodromesenfete.fr/jouons-responsable/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:opacity-80 transition-opacity"
              aria-label="Jouons Responsable"
            >
              <img
                src="/images/footer/jouns.webp"
                alt="Jouons Responsable"
                className="h-10 w-auto"
                loading="lazy"
              />
            </a>
            <a
              href="https://www.data.gouv.fr/en/organizations/autorite-de-regulation-des-jeux-en-ligne-arjel/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:opacity-80 transition-opacity"
              aria-label="ARJEL"
            >
              <img
                src="/images/footer/arjel.webp"
                alt="ARJEL"
                className="h-10 w-auto"
                loading="lazy"
              />
            </a>
            <a
              href="https://mediateurdesjeuxenligne.fr/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:opacity-80 transition-opacity"
              aria-label="Médiateur des Jeux en Ligne"
            >
              <img
                src="/images/footer/mediater.webp"
                alt="Médiateur des Jeux en Ligne"
                className="h-10 w-auto"
                loading="lazy"
              />
            </a>
            <a
              href="https://www.gambleaware.org/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:opacity-80 transition-opacity"
              aria-label="BeGambleAware"
            >
              <img
                src="/images/footer/begamble.webp"
                alt="BeGambleAware"
                className="h-10 w-auto"
                loading="lazy"
              />
            </a>
          </div>
        </div>

        <div className="border-t border-dark-border pt-8 text-center">
          <p className="text-gray-400 text-sm">
            © {currentYear} BetSprinto.com. Tous droits réservés.
          </p>
          <p className="text-gray-500 text-xs mt-2">
            Les paris sportifs peuvent créer une dépendance. Jouez de manière responsable.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

